import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as HorizontalOptionsIcon } from '@assets/icons/horizontal-options.svg';

export const StyledSectionTitle = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '$6',
  width: '100%',

  'span': {
    color: '$black',
    fontSize: '$md',
    fontWeight: 'normal',
  },

  'ul': {
    minWidth: '150px'
  }
});

export const StyledTitle = styled(Box, {
  color: '$darkBlue300',
  display: 'flex',
  fontSize: '$2xl',
});

export const Icon = styled(HorizontalOptionsIcon, {});
